<template>
  <div id="questionview">
    <v-container class="fill-height" fluid>
       <v-row align="center" justify="center"><h1>Bot Users</h1></v-row>
    </v-container>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64" ></v-progress-circular>
    </v-overlay>  
  </div>
   <v-data-table  :headers="headers"  :mobile-breakpoint="0"  :items="userList" >
     <template v-slot:item="{ item,index }"  >
       <tr :class="item.color">
          <td>{{ item.id }}</td>
          <td class="text-left">{{ item.firstname }} {{ item.lastname }}</td>
          <td class="text-left">{{item.role}}</td>
          <td class="text-left"><img :src="item.filename" heigh="80" width="80"></td>
          <td>
            <div class="options">
              <v-icon small class="mr-2" @click="editItem(item,index)">mdi-pencil</v-icon>
            </div>
           </td>
        </tr>
      </template>   
     </v-data-table>    
     <v-dialog v-model="userdialog" max-width="650px">
        <v-card>
         <v-card-title>
           <span>Edit User</span>
         </v-card-title>
         <v-card-text>
           <v-container>
             <v-row>
               <v-col cols="6" sm="6" md="6">
                 <v-text-field v-model="editedItem.firstname" label="firstname"></v-text-field>
               </v-col>
               <v-col cols="6" sm="6" md="6">
                 <v-text-field v-model="editedItem.lastname" label="lastname"></v-text-field>
               </v-col>
             </v-row>
            
              <v-row>
               <v-col cols="6" sm="6" md="6">
                  <img :src="editedItem.filename" heigh="80" width="80">
               </v-col>
               <v-col cols="6" sm="6" md="6">
                <input type="file" id="files" ref="files"  v-on:change="handleFilesUpload()"/>
               </v-col>
             </v-row>
            
              
            
           </v-container>
         </v-card-text>
         <v-card-actions>
           <v-spacer></v-spacer>
           <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
           <v-btn color="blue darken-1" text @click="save">Save</v-btn>
         </v-card-actions>
        </v-card>
       </v-dialog>
 </div>   
</template>
<script>
export default {
  name: "Userslist",
  data() {
    return {
      overlay: false,
      userdialog:false,
      userList:[],
      editedItem:[],
      files:[],
      index:''
    };
  },
  computed: {
     headers(){
        let headers = [
              { text:"Quizstar_Id", value: "sno" },
              { text:"Name  ",align: "question",value: "question",sortable: true},
              { text:"Role  ",value: "role"},
              { text:"Avatar  ",value: "avatar"},
              { text:"Action", value: "" },
         ]
         return headers
      },
    },    
  created(){
     this.overlay = true;
     this.getAllBotUser();
  },
  methods:{
    getAllBotUser(){
        this.$store.dispatch("getBotUsers").then((response) => {
            this.overlay = false;
            this.userList = response.data;
        });
    },
    close(){
       this.editedItem = [];
       this.dialog     = false;
       this.addpayment='';
       this.sno1 = '';
       this.userdialog     = false;
    },
    handleFilesUpload(){
        let uploadedFiles = this.$refs.files.files;
         
        for( var i = 0; i < uploadedFiles.length; i++ ){
          this.files.push( uploadedFiles[i] );
        }
      },
     editItem(item,index){
       this.editedItem = item;
       this.userdialog     = true;
       this.index = index;
    },
    save(){
        
      var add_user_id = this.editedItem.id;
      var firstname   = this.editedItem.firstname;
      var lastname   = this.editedItem.lastname;
      let formData = new FormData();
      if(typeof this.files != "undefined")
      {
        formData.append('avatar', this.files[0]);
      } 
        
     formData.append('id', add_user_id);
     formData.append('firstname', firstname);
     formData.append('lastname', lastname);
  
      this.$store.dispatch("updateInbank",
        formData
        ).then(() => {
          this.files = [];
         this.dialog = false;
         this.userdialog     = false;
         this.getAllBotUser();          
      });
    },
  }
}  
</script>
